import { message } from '~/services/messages'

export enum ExamClassification {
  IMAGE = 1,
  LABORATORY = 2
}

export const examsProcedures = [
  {
    label: message('examsProcedures.imagem'),
    value: ExamClassification.IMAGE
  },
  {
    label: message('examsProcedures.laboratorial'),
    value: ExamClassification.LABORATORY
  }
]

export const admissionReasons = [
  {
    label: message('examsProcedures.preQuimio'),
    value: 1
  },
  {
    label: message('examsProcedures.rotina'),
    value: 2
  }
]
